import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const PAGINATION_WIDTH = 7;
export function preparePagination(options) {
  const {
    totalPages,
    currentPage
  } = options;
  // если общее количеств страниц не больше кол-ва элементов в блоке PAGINATION_WIDTH, выводим все
  if (totalPages <= PAGINATION_WIDTH) {
    return Array.from({
      length: totalPages
    }, (_, index) => preparePage(_objectSpread({
      page: index + 1
    }, options)));
  }
  const pagination = [];
  const endPage = Math.min(Math.max(PAGINATION_WIDTH, currentPage + 3), totalPages);
  const startPage = endPage - 5;

  // В блоке пагинации всегда отображаем 1 страницу
  // [1] [startPage] [ ] [ ] [ ] [ ] [endPage]
  pagination.push(preparePage(_objectSpread({
    page: 1
  }, options)));
  const mainRange = Array.from({
    length: endPage - startPage + 1
  }, (_, index) => startPage + index);
  mainRange.forEach((page, index) => {
    let title;
    if (index === 0 && page > 2 || index === mainRange.length - 1 && page < totalPages) {
      title = '...';
    }
    pagination.push(preparePage(_objectSpread({
      page,
      title
    }, options)));
  });
  return pagination;
}
function preparePage(_ref) {
  let {
    page,
    currentPage,
    title
  } = _ref;
  return {
    page,
    disabled: page === currentPage,
    title: title || page.toString()
  };
}